import { MapEditorFeatureCreateOptionsSelect_EcologicalFunctionFragment } from "../fragments.generated";

type IdNamePair = { id: string; name: string };

type EcologicalFunctionTypeMap = Map<
    string,
    {
        ecologicalFunctionType: MapEditorFeatureCreateOptionsSelect_EcologicalFunctionFragment["ecologicalFunctionTypes"][number];
        researchType: MapEditorFeatureCreateOptionsSelect_EcologicalFunctionFragment;
    }
>;

/**
 * Builds species list and ecological function type map.
 * Only collects species from research types that have at least one ecological function type.
 */
export function buildDataMaps(researchTypes: MapEditorFeatureCreateOptionsSelect_EcologicalFunctionFragment[]) {
    const speciesMap = new Map<string, IdNamePair>();
    const ecologicalFunctionTypeMap: EcologicalFunctionTypeMap = new Map();

    researchTypes.forEach(researchType => {
        // Only include species if this research type has ecological function types
        if (researchType.ecologicalFunctionTypes.length > 0) {
            researchType.speciesV2.forEach(({ species }) => {
                speciesMap.set(species.id, species);
            });
        }

        // Build ecological function type lookup map
        researchType.ecologicalFunctionTypes.forEach(ecologicalFunctionType => {
            ecologicalFunctionTypeMap.set(ecologicalFunctionType.id, {
                ecologicalFunctionType,
                researchType,
            });
        });
    });

    return {
        allSpecies: Array.from(speciesMap.values()).sort((a, b) => a.name.localeCompare(b.name)),
        ecologicalFunctionTypeMap,
    };
}
